import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { utils } from '../helper/utils';
import {
  BookingAssignment,
  BookingAssignmentDetailResponse,
  BookingAssignmentPagedResult,
  EligibilityCheckResponse,
  SubmitBookingAssignmentsRequestItem,
} from '../models/booking-assignment.model';

@Injectable({ providedIn: 'root' })
export class BookingAssignmentService {
  private readonly httpClient = inject(HttpClient);

  fetchBookingAssignmentsPage(
    maintenanceShopCode: string,
    page: number,
    limit: number,
  ): Observable<BookingAssignmentPagedResult<BookingAssignment>> {
    const params = new HttpParams().set('page', page).set('limit', limit);
    return this.httpClient.get<BookingAssignmentPagedResult<BookingAssignment>>(
      utils.GetContainerSteeringAPIUrl(`booking-assignment/maintenance-shops/${encodeURIComponent(maintenanceShopCode)}/booking-equipment`),
      { params },
    );
  }

  getBookingDetail(maintenanceShopCode: string, bookingNumber: string): Observable<BookingAssignmentDetailResponse> {
    return this.httpClient.get<BookingAssignmentDetailResponse>(
      utils.GetContainerSteeringAPIUrl(
        `booking-assignment/maintenance-shops/${encodeURIComponent(maintenanceShopCode)}/bookings/${encodeURIComponent(bookingNumber)}`,
      ),
    );
  }

  checkEquipmentEligibility(
    maintenanceShopCode: string,
    bookingNumber: string,
    equipmentNumber: string,
  ): Observable<EligibilityCheckResponse> {
    return this.httpClient.post<EligibilityCheckResponse>(
      utils.GetContainerSteeringAPIUrl(
        `booking-assignment/maintenance-shops/${encodeURIComponent(maintenanceShopCode)}/bookings/${encodeURIComponent(bookingNumber)}/equipment/${encodeURIComponent(equipmentNumber)}/assignment-audits`,
      ),
      null,
    );
  }

  deleteAssignmentAudit(maintenanceShopCode: string, bookingNumber: string, equipmentNumber: string): Observable<string> {
    return this.httpClient.delete(
      utils.GetContainerSteeringAPIUrl(
        `booking-assignment/maintenance-shops/${encodeURIComponent(maintenanceShopCode)}/bookings/${encodeURIComponent(bookingNumber)}/equipment/${encodeURIComponent(equipmentNumber)}/assignment-audits`,
      ),
      { responseType: 'text' },
    );
  }

  submitBookingAssignments(
    maintenanceShopCode: string,
    bookingNumber: string,
    payload: SubmitBookingAssignmentsRequestItem[],
  ): Observable<string> {
    return this.httpClient.post(
      utils.GetContainerSteeringAPIUrl(
        `booking-assignment/maintenance-shops/${encodeURIComponent(maintenanceShopCode)}/bookings/${encodeURIComponent(bookingNumber)}/booking-equipment`,
      ),
      payload,
      { responseType: 'text' },
    );
  }
}
